import React from 'react';
import './App.css';
import { Provider } from "mobx-react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";


import Core from './components/Core';
import Overview from './components/Overview';
import Planner from './components/Planner';
import Product from './components/Product';
import StoreOverview from './components/StoreOverview';
import Store from './components/Store';
import Pod from './components/Pod';
import Start from './components/Start';

var state   = window.core   = new Core;



function App() {
  return (
		<Router>
			<Provider core={state}>
					<Switch>
						<Route exact path="/" component={() => { return <div><h1>No Pod Selected</h1>Please navigate to a URL that contains a valid pod.</div> }} />
						<Route exact path="/x-pod_create_sabes_como" component={() => { return <Start /> }} />
						<Route exact path="/:pod_id/" component={(match) => {  return <Pod url={match} pod_id={match.match.params.pod_id}><Planner /></Pod>} } />
						<Route path="/:pod_id/overview" component={(match) => { return <Pod url={match} pod_id={match.match.params.pod_id}><Overview /></Pod>} } />
						<Route path="/:pod_id/product/:product_id" component={(match) => { return <Pod url={match} pod_id={match.match.params.pod_id}><Product product_id={match.match.params.product_id} /></Pod>} } />
						<Route exact path="/:pod_id/stores" component={(match) => <Pod url={match} pod_id={match.match.params.pod_id}><StoreOverview/></Pod>} />
						<Route path="/:pod_id/store/:store_id" component={(match) => <Pod url={match} pod_id={match.match.params.pod_id}><Store store_id={match.match.params.store_id} /></Pod>} />
						<Route component={(match) => { console.warn(match); return <div>404 Route Not Found</div>}} />
					</Switch>
			</Provider>
		</Router>
  );
}

export default App;
